import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.14.1592_@biomejs+biome@1.9.4_@parcel+watcher@2.4.1_@types+node@22.7.5_eslint@9.12.0_ji_3i7jl43cgwpk52v6edo4lkplii/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}